import React, { createContext } from "react"

const Context = createContext()

function LocaleProvider({ children }) {
  return (
    <Context.Provider value={{ locale: "bg" }}>{children}</Context.Provider>
  )
}
export { LocaleProvider }

export default Context
